import { CreateEmitter, SearchEmitter, UpdateEmitter } from '@/types/emitter'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

const emitterDataConfigApi = {
  getAll(searchParams: SearchEmitter) {
    const url = '/api/emitter'
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getById(interfaceId: string, id: string) {
    const url = `/api/emitter/${interfaceId}/${id}`
    return axiosClient.get(url)
  },

  create(payload: CreateEmitter) {
    const url = '/api/emitter'
    return axiosClient.post(url, payload)
  },

  delete(interfaceId: string, id: string) {
    const url = `/api/emitter/?interfaceId=${interfaceId}&id=${id}`
    return axiosClient.delete(url)
  },
  update(payload: UpdateEmitter) {
    const url = '/api/emitter'
    return axiosClient.put(url, payload)
  },
}

export default emitterDataConfigApi
